export const I_API = "i_api";
export const I_COMPONENT = "i_component";
export const I_KPOD = "i_kpod";
export const I_BIZOUTCOME = "i_bizoutcome";
